module.exports = __webpack_public_path__ + "assets/01.f4cb7207.pdf";